export default __webpack_public_path__ + "static/media/Pot2.c3d6954e.svg";